import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecentSegments } from './useRecentSegments';
import { segmentDotClass } from './segmentColor';
import { relativeShort } from './relativeTime';

/**
 * RECENT SEGMENTS, with the count on the right of the heading.
 *
 * A row opens the Funnel on that persona (`?persona=<id>`), which is how the
 * Funnel already restores a saved audience — only from a link instead of from
 * its modal.
 */
export const RecentSegments: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { segments, total, isLoading } = useRecentSegments();

  if (isLoading || segments.length === 0) return null;

  return (
    <div className="pt-[18px]" data-testid="recent-segments">
      <div className="flex items-center justify-between px-3 pb-1 text-[11px] leading-[normal]">
        <p className="font-semibold uppercase tracking-[0.88px] text-[rgba(11,11,11,0.5)] dark:text-white/50">
          {t('app.v11.shell.sections.recentSegments')}
        </p>
        <span className="font-medium text-[rgba(11,11,11,0.3)] dark:text-white/30">{total}</span>
      </div>

      <ul className="flex flex-col gap-1">
        {segments.map(segment => (
          <li key={segment.id}>
            <Link
              to={`/v11/funnel?persona=${segment.id}`}
              className="flex items-center gap-3 rounded-[8px] px-3 py-2 transition hover:bg-v11-surface-hover"
            >
              <span
                aria-hidden="true"
                className="flex h-3.5 w-3.5 shrink-0 items-center justify-center"
              >
                <span className={`h-2 w-2 rounded-full ${segmentDotClass(segment.id)}`} />
              </span>
              <span className="min-w-0 flex-1 truncate text-[13px] font-medium leading-[18px] text-v11-text-primary">
                {segment.name}
              </span>
              <span className="shrink-0 text-[11px] leading-[normal] text-[rgba(11,11,11,0.3)] dark:text-white/30">
                {relativeShort(segment.updatedAt, i18n.language)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
